export default function TemplatesPage() {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900">Modèles publics</h2>
      <p className="mt-4 text-gray-600">La galerie de modèles publics sera affichée ici.</p>
    </div>
  );
}
